import { render, staticRenderFns } from "./Cardholder.vue?vue&type=template&id=63723092"
import script from "./Cardholder.vue?vue&type=script&lang=js"
export * from "./Cardholder.vue?vue&type=script&lang=js"
import style0 from "./Cardholder.vue?vue&type=style&index=0&id=63723092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports